import { render } from "./recent-folder.vue?vue&type=template&id=25e9ddbc"
import script from "./recent-folder.vue?vue&type=script&lang=js"
export * from "./recent-folder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__